<template>
  <div class="people">
    <Header :right-sidebar="true" right-sidebar-title="Личные карточки">
      <template #right-sidebar>
        <sidebar-items-group title="Отображать столбцы">
          <fields-picker
            v-model="pickedFields"
            :fields="peopleDisplayableFields"
          />
        </sidebar-items-group>
        <sidebar-items-group title="Фильтры">
          <filters-group
            :fields="peopleFields"
            :items="people"
            storeName="people"
            v-model="filteredItems"
          />
        </sidebar-items-group>
        <sidebar-item variant="success" to="/people/create">
          Добавить человека
          <template #icon>
            <b-icon icon="plus-square" />
          </template>
        </sidebar-item>
        <sidebar-item variant="info" button @click="googleContactsExport">
          Экспорт в Google Contacts
          <template #icon>
            <b-icon icon="file-earmark-person-fill" />
          </template>
        </sidebar-item>
      </template>
    </Header>
    <Main>
      <b-overlay :show="!loaded">
        <b-table
          selectable
          select-mode="single"
          :responsive="true"
          :items="paintedRows"
          :fields="pickedFields"
          @row-clicked="item => openPerson(item)"
          hover
          class="table-rounded"
          empty-text="Записей нет"
        />
      </b-overlay>
    </Main>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import Main from "@/components/Layout/Main";
import FieldsPicker from "@/components/Tables/FieldsPicker";
import { peopleFields } from "./models/peopleTableModel.js";
import SidebarItemsGroup from "@/components/Layout/Sidebars/SidebarItems/SidebarItemsGroup";
import FiltersGroup from "@/components/Tables/Filters/FiltersGroup";
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import { displayableFields } from "@/components/Tables/defaultFields";
import { mapGetters } from "vuex";
import { peopleRowPainter } from "@/components/Tables/rowPainters";
import pageTitleMixin from "@/mixins/pageTitleMixin";
import { getGoogleContactObject } from "@/components/Tables/formatters";
import { downloadFile } from "@/helpers/downloadFile";

export default {
  components: {
    SidebarItem,
    FiltersGroup,
    SidebarItemsGroup,
    FieldsPicker,
    Main,
    Header
  },
  mixins: [pageTitleMixin],
  data() {
    let peopleDisplayableFields = displayableFields(peopleFields);
    return {
      peopleFields,
      peopleDisplayableFields,
      filteredItems: [],
      pickedFields: [...peopleDisplayableFields]
    };
  },
  computed: {
    ...mapGetters("unions", { unionsLoaded: "loaded" }),
    ...mapGetters("services", { servicesLoaded: "loaded" }),
    ...mapGetters("professionalGroups", { professionalGroupsLoaded: "loaded" }),
    ...mapGetters("people", { people: "people", peopleLoaded: "loaded" }),
    paintedRows: ({ filteredItems }) => peopleRowPainter(filteredItems),
    loaded: ({
      unionsLoaded,
      servicesLoaded,
      professionalGroupsLoaded,
      peopleLoaded
    }) =>
      unionsLoaded && servicesLoaded && professionalGroupsLoaded && peopleLoaded
  },
  methods: {
    openPerson({ id }) {
      this.$router.push(`/people/${id}`);
    },
    googleContactsExport() {
      if (this.filteredItems.length === 0)
        this.$eventHub.$emit(
          "showError",
          "Нет ни одной личной карточки, соответсвующей фильтрам!"
        );
      let googleContacts = this.filteredItems.map(getGoogleContactObject);
      let largestContact = {};
      googleContacts.forEach(contact => {
        if (Object.keys(contact).length > Object.keys(largestContact).length)
          largestContact = contact;
      });

      let csvFileContents = "";

      csvFileContents += Object.keys(largestContact).join(";") + "\n";

      googleContacts.forEach(contact => {
        csvFileContents +=
          Object.keys(largestContact)
            .map(key => (contact[key] !== undefined ? contact[key] : ""))
            .join(";") + "\n";
      });

      downloadFile(
        Buffer.from(csvFileContents).toString("utf8"),
        "google contacts.csv",
        "text/plain"
      );
    }
  }
};
</script>
